
export default function Contact() {
  const openWhatsApp = () => {
    window.open('https://wa.me/5544988010206?text=Hello, I would like to talk about Social Security Law', '_blank');
  };

  return (
    <section id="contato" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Contact Us
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            We are ready to help you with your social security questions
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* WhatsApp Highlight */}
            <div className="text-center md:text-left">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-green-600 rounded-full mb-6">
                <i className="ri-whatsapp-line text-3xl text-white"></i>
              </div>

              <h3 className="text-2xl font-semibold text-white mb-4">
                WhatsApp Service
              </h3>

              <p className="text-gray-400 mb-6 leading-relaxed">
                Talk directly with our specialized team. Quick response and personalized service.
              </p>

              <button
                onClick={openWhatsApp}
                className="inline-flex items-center px-8 py-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                (44) 98801-0206
              </button>

              <p className="text-[#b86846] font-medium mt-4">
                Online service throughout Brazil
              </p>
            </div>

            {/* Social Media */}
            <div className="text-center">
              <h3 className="text-xl font-semibold text-white mb-6">
                Follow us on social media
              </h3>

              <div className="flex justify-center flex-wrap gap-4">
                <a
                  href="https://instagram.com/laginestraadvogados"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl text-white"></i>
                </a>

                <button
                  onClick={openWhatsApp}
                  className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl text-white"></i>
                </button>

                <a
                  href="https://www.youtube.com/@LaginestraAdvogados"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-youtube-fill text-xl text-white"></i>
                </a>

                <a
                  href="https://www.tiktok.com/@laginestra.advoga"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-black rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer border border-white"
                >
                  <i className="ri-tiktok-fill text-xl text-white"></i>
                </a>
              </div>

              <p className="text-gray-400 mt-6 text-sm">
                Educational content about Social Security Law
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
